import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { Picker } from 'antd-mobile';
import styles from './index.css';
import errorBoundary from '@ifeng-fe/errorBoundary';
import { area } from '@src/utils/area';

const FormSelect = ({ name, formData, optionValueList, changeInputHandle, languages }) => {
    const [selectValue, setSelectValue] = useState('');
    const [visible, setVisible] = useState(false);

    const changeHandle = (value) => {
        setSelectValue(value);
        changeInputHandle(name, value);
    };

    const pickerList = optionValueList.map((item) => {
        return {
            label: item,
            value: item,
        };
    });
    let defaultValue = formData?.[name] || selectValue || '';

    if (languages === 'zh' || languages === 'ch') {
        if (defaultValue === 'Male') {
            defaultValue = '男';
        }
        if (defaultValue === 'Female') {
            defaultValue = '女';
        }
    }
    if (languages === 'en') {
        if (defaultValue === '男') {
            defaultValue = 'Male';
        }
        if (defaultValue === '女') {
            defaultValue = 'Female';
        }
    }

    return (
        <div className={styles.formInputBox}>
            <div
                onClick={() => {
                    setVisible(true);
                }}>
                <div className={`${styles.formSelect} ${defaultValue !== '' ? styles.active : ''}`}>{defaultValue || area[languages].gender.selectDefault}</div>
            </div>
            <Picker
                defaultValue={[defaultValue]}
                columns={[pickerList]}
                visible={visible}
                onConfirm={(value) => {
                    changeHandle(value?.[0] || '');
                }}
                onClose={() => {
                    setVisible(false);
                }}
                cancelText={area[languages].gender.cancelText}
                confirmText={area[languages].gender.confirmText}
            />
        </div>
    );
};

FormSelect.propTypes = {
    name: PropTypes.string,
    formData: PropTypes.object,
    changeInputHandle: PropTypes.func,
    optionValueList: PropTypes.array,
    languages: PropTypes.string,
};

export default errorBoundary(FormSelect);
